import { FC } from 'react';

import CollapsibleListItem, { CollapsibleListItemProps } from './CollapsibleListItem';

import styles from './CollapsibleList.module.scss';

interface Props {
  dataTestId?: string;
  isExpanded?: boolean;
  listItems: Array<CollapsibleListItemProps & { key?: string }>;
  listItemsHeaderVariant: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p';
}

const CollapsibleList: FC<Props> = ({
  dataTestId,
  isExpanded = false,
  listItems = [],
  listItemsHeaderVariant,
}) => (
  <div className={styles['container']} data-test-id={dataTestId}>
    {listItems.map(({ content, title, key }) => (
      <CollapsibleListItem
        key={key ?? title}
        content={content}
        isExpanded={isExpanded}
        title={title}
        headerVariant={listItemsHeaderVariant}
      />
    ))}
  </div>
);

export default CollapsibleList;
export type { Props as CollapsibleListProps };
